import React from 'react'
import { Row, Col, Result, Skeleton, Divider } from 'antd'
import { FormComponent } from '../../../BaseComponent'
import { IntegrationConsumer, IntegrationContextData } from '../../../../context/IntegrationContext'
import { IntegrationFormProps } from '..'
import DashboardSettings from './Settings'
import DashboardDefinitions from './Definitions'
import DashboardSections from './Sections'
import DashboardTotal from './Total'

export default class IntegrationDashboard extends FormComponent<IntegrationFormProps> {

  state = {
    loaded: false
  }

  private async load(context: IntegrationContextData) {
    const { integrationUuid = '' } = this.props

    await context.requestPreview({
      integration_uuid: integrationUuid
    })

    this.setState({
      loaded: true
    })
  }

  render() {    
    if (!this.props.integrationUuid) {
      return (
        <Result
          title="Integration not found"
          status="404"
        />
      )
    }

    return (
      <IntegrationConsumer>
        {(context) => {
          if (!context.fetching && !context.preview) {
            setTimeout(() => {
              this.load(context)
            }, 500)
          }else if(!context.fetching && context.preview && !this.state.loaded){
            this.setState({
              loaded: true
            })
          }

          if (!this.state.loaded) {
            return <Skeleton />
          }

          return (
            <div>
              <Row gutter={12}>
                <Col xs={24} md={8}>
                  <DashboardSettings integrationUuid={this.props.integrationUuid || ''} context={context} />
                </Col>

                <Col xs={24} md={10}>
                  <DashboardSections integrationUuid={this.props.integrationUuid || ''} context={context} />
                </Col>

                <Col xs={24} md={6}>
                  <DashboardTotal integrationUuid={this.props.integrationUuid || ''} context={context} />
                </Col>
              </Row>

              <Divider />

              <Row>
                <Col xs={24}>
                  <DashboardDefinitions integrationUuid={this.props.integrationUuid || ''} context={context} />
                </Col>
              </Row>
            </div>
          )
        }}
      </IntegrationConsumer>
    )
  }
}
